import type { Locale } from '../../i18n';

const RU = {
  'lpr.title': 'Распознавание номеров',
  'lpr.site.required': 'Выберите объект в шапке',
  'lpr.notConfigured': 'Распознавание на объекте не настроено',
  'lpr.loading': 'Загрузка…',
  'lpr.refresh': 'Обновить',
  'lpr.period.day': 'Сутки',
  'lpr.period.week': 'Неделя',
  'lpr.period.month': 'Месяц',

  'lpr.subtitle': 'Качество распознавания, задержки по участкам, камеры и настройка объекта',
  'lpr.tiles.total': 'Распознаваний',
  'lpr.tiles.recognized': 'Номер прочитан',
  'lpr.tiles.lowConfidence': 'Доля низкой уверенности',
  'lpr.tiles.manual': 'Доля ручных вводов',
  'lpr.tiles.failed': 'Доля неуспехов',
  'lpr.tiles.unacked': 'Без подтверждения отрисовки',

  'lpr.tiles.recognizedHint': 'Камера прочитала номер: без учёта низкой уверенности и отказов',
  'lpr.breakdown.identifiedHint': 'Визит связался с профилем клиента — это другое число',
  'lpr.latency.noAcks':
    'Замеров нет: планшеты не присылали подтверждений отрисовки. Участок считается от подтверждения, поэтому без него метрика пуста.',
  'lpr.vendor.manualOnly': 'Счётчик заполняется кадрами камер; ручные вводы в него не попадают.',
  'lpr.latency.title': 'Задержка по участкам, p95',
  'lpr.latency.stage': 'Участок',
  'lpr.latency.samples': 'Замеров',
  'lpr.latency.p50': 'p50, мс',
  'lpr.latency.p95': 'p95, мс',
  'lpr.latency.vendor': 'Вендор: кадр → приём',
  'lpr.latency.resolve': 'Ядро: поиск клиента',
  'lpr.latency.deliver': 'Доставка на планшет',
  'lpr.latency.render': 'Отрисовка на планшете',
  'lpr.latency.total': 'Итого от кадра до карточки',
  'lpr.latency.budget': 'Бюджет — 3000 мс от метки кадра, p95 за сутки',

  'lpr.vendor.title': 'Вендор',
  'lpr.vendor.available': 'Связь есть',
  'lpr.vendor.unavailable': 'Связи нет — ручной ввод',
  'lpr.vendor.lastSeen': 'Последний кадр',
  'lpr.vendor.never': 'кадров от камер не приходило',
  'lpr.vendor.check': 'Проверить связь',

  'lpr.cameras.title': 'Камеры',
  'lpr.cameras.code': 'Код',
  'lpr.cameras.label': 'Название',
  'lpr.cameras.direction': 'Направление',
  'lpr.cameras.entry': 'Въезд',
  'lpr.cameras.exit': 'Выезд',
  'lpr.cameras.vendorId': 'Идентификатор у вендора',
  'lpr.cameras.status': 'Состояние',
  'lpr.cameras.active': 'Активна',
  'lpr.cameras.disabled': 'Отключена',
  'lpr.cameras.add': 'Сохранить камеру',
  'lpr.cameras.empty': 'Камеры не заведены',

  'lpr.config.title': 'Настройка объекта',
  'lpr.config.vendor': 'Вендор',
  'lpr.config.endpoint': 'Адрес развёртывания',
  'lpr.config.threshold': 'Порог уверенности',
  'lpr.config.thresholdHint':
    'Ниже порога карточка не показывается автоматически — оператор вводит номер вручную.',
  'lpr.config.window': 'Окно дедупликации, мс',
  'lpr.config.silence': 'Молчание вендора, мс',
  'lpr.config.rotate': 'Перевыпустить секрет вебхука',
  'lpr.config.save': 'Сохранить настройку',
  'lpr.config.latitude': 'Широта объекта',
  'lpr.config.longitude': 'Долгота объекта',
  'lpr.config.minRate': 'Порог приёмки ночью и в осадки',
  'lpr.config.coordsHint':
    'Координаты нужны, чтобы знать, темно ли на кадре, и спросить погоду, если камера её не присылает. Порог приёмки — доля распознанных кадров; до пилотного замера 0,90.',
  'lpr.conditions.title': 'Приёмка по условиям съёмки',
  'lpr.conditions.night': 'Ночь',
  'lpr.conditions.precipitation': 'Осадки',
  'lpr.conditions.day_dry': 'День без осадков',
  'lpr.conditions.attempts': 'Кадров',
  'lpr.conditions.rate': 'Распознано',
  'lpr.conditions.threshold': 'Порог',
  'lpr.conditions.pass': 'Проходит',
  'lpr.conditions.fail': 'Ниже порога',
  'lpr.conditions.none': 'Нет кадров',
  'lpr.cycle.title': 'Время цикла (камера выезда)',
  'lpr.cycle.samples': 'Выездов',
  'lpr.cycle.avg': 'Среднее',
  'lpr.config.secret': 'Секрет показан один раз, сохраните его',

  'lpr.breakdown.camera': 'По камерам',
  'lpr.breakdown.hour': 'По часам суток',
  'lpr.breakdown.weather': 'По погоде',
  'lpr.breakdown.total': 'Всего',
  'lpr.breakdown.identified': 'Клиент опознан',
  'lpr.breakdown.low': 'Низкая уверенность',
  'lpr.breakdown.failed': 'Неуспехи',
  'lpr.breakdown.hourColumn': 'Час',
  'lpr.breakdown.empty': 'Данных за период нет',

  'lpr.licence.title': 'Расход лицензий вендора',
  'lpr.licence.calls': 'Обращений',
  'lpr.licence.units': 'Единиц',
  'lpr.licence.failures': 'Ошибок',
} as const;

const KK: Record<keyof typeof RU, string> = {
  'lpr.title': 'Нөмірлерді тану',
  'lpr.site.required': 'Жоғарыдан нысанды таңдаңыз',
  'lpr.notConfigured': 'Нысанда тану бапталмаған',
  'lpr.loading': 'Жүктелуде…',
  'lpr.refresh': 'Жаңарту',
  'lpr.period.day': 'Тәулік',
  'lpr.period.week': 'Апта',
  'lpr.period.month': 'Ай',

  'lpr.subtitle': 'Тану сапасы, учаскелер бойынша кідірістер, камералар және нысан баптауы',
  'lpr.tiles.total': 'Тану саны',
  'lpr.tiles.recognized': 'Нөмір оқылды',
  'lpr.tiles.lowConfidence': 'Төмен сенімділік үлесі',
  'lpr.tiles.manual': 'Қолмен енгізу үлесі',
  'lpr.tiles.failed': 'Сәтсіздік үлесі',
  'lpr.tiles.unacked': 'Көрсетілім расталмаған',

  'lpr.tiles.recognizedHint': 'Камера нөмірді оқыды: төмен сенімділік пен бас тартуларсыз',
  'lpr.breakdown.identifiedHint': 'Келу клиент профиліне байланды — бұл басқа сан',
  'lpr.latency.noAcks':
    'Өлшеу жоқ: планшеттер сурет салу растауын жіберген жоқ. Учаске растаудан есептеледі.',
  'lpr.vendor.manualOnly': 'Есептегіш камера кадрларымен толтырылады; қолмен енгізу оған кірмейді.',
  'lpr.latency.title': 'Кезеңдер бойынша кідіріс, p95',
  'lpr.latency.stage': 'Кезең',
  'lpr.latency.samples': 'Өлшеу саны',
  'lpr.latency.p50': 'p50, мс',
  'lpr.latency.p95': 'p95, мс',
  'lpr.latency.vendor': 'Жеткізуші: кадр → қабылдау',
  'lpr.latency.resolve': 'Өзек: клиентті іздеу',
  'lpr.latency.deliver': 'Планшетке жеткізу',
  'lpr.latency.render': 'Планшетте көрсету',
  'lpr.latency.total': 'Кадрдан картаға дейін барлығы',
  'lpr.latency.budget': 'Бюджет — кадр белгісінен 3000 мс, тәулігіне p95',

  'lpr.vendor.title': 'Жеткізуші',
  'lpr.vendor.available': 'Байланыс бар',
  'lpr.vendor.unavailable': 'Байланыс жоқ — қолмен енгізу',
  'lpr.vendor.lastSeen': 'Соңғы кадр',
  'lpr.vendor.never': 'кадр болған жоқ',
  'lpr.vendor.check': 'Байланысты тексеру',

  'lpr.cameras.title': 'Камералар',
  'lpr.cameras.code': 'Коды',
  'lpr.cameras.label': 'Атауы',
  'lpr.cameras.direction': 'Бағыты',
  'lpr.cameras.entry': 'Кіру',
  'lpr.cameras.exit': 'Шығу',
  'lpr.cameras.vendorId': 'Жеткізушідегі идентификатор',
  'lpr.cameras.status': 'Күйі',
  'lpr.cameras.active': 'Белсенді',
  'lpr.cameras.disabled': 'Өшірілген',
  'lpr.cameras.add': 'Камераны сақтау',
  'lpr.cameras.empty': 'Камералар тіркелмеген',

  'lpr.config.title': 'Нысанды баптау',
  'lpr.config.vendor': 'Жеткізуші',
  'lpr.config.endpoint': 'Орналастыру мекенжайы',
  'lpr.config.threshold': 'Сенімділік шегі',
  'lpr.config.thresholdHint':
    'Шектен төмен болса карта автоматты көрсетілмейді — оператор нөмірді қолмен енгізеді.',
  'lpr.config.window': 'Дедупликация терезесі, мс',
  'lpr.config.silence': 'Жеткізушінің үнсіздігі, мс',
  'lpr.config.rotate': 'Вебхук құпия сөзін қайта шығару',
  'lpr.config.save': 'Баптауды сақтау',
  'lpr.config.latitude': 'Нысанның ендігі',
  'lpr.config.longitude': 'Нысанның бойлығы',
  'lpr.config.minRate': 'Түнде және жауын-шашында қабылдау шегі',
  'lpr.config.coordsHint':
    'Координаттар кадрдың қараңғы екенін білу және камера жібермесе ауа райын сұрау үшін қажет. Қабылдау шегі — танылған кадрлар үлесі; пилоттық өлшемге дейін 0,90.',
  'lpr.conditions.title': 'Түсіру жағдайы бойынша қабылдау',
  'lpr.conditions.night': 'Түн',
  'lpr.conditions.precipitation': 'Жауын-шашын',
  'lpr.conditions.day_dry': 'Жауынсыз күн',
  'lpr.conditions.attempts': 'Кадрлар',
  'lpr.conditions.rate': 'Танылды',
  'lpr.conditions.threshold': 'Шек',
  'lpr.conditions.pass': 'Өтеді',
  'lpr.conditions.fail': 'Шектен төмен',
  'lpr.conditions.none': 'Кадр жоқ',
  'lpr.cycle.title': 'Цикл уақыты (шығу камерасы)',
  'lpr.cycle.samples': 'Шығулар',
  'lpr.cycle.avg': 'Орташа',
  'lpr.config.secret': 'Құпия сөз бір рет көрсетіледі, сақтап қойыңыз',

  'lpr.breakdown.camera': 'Камералар бойынша',
  'lpr.breakdown.hour': 'Тәулік сағаттары бойынша',
  'lpr.breakdown.weather': 'Ауа райы бойынша',
  'lpr.breakdown.total': 'Барлығы',
  'lpr.breakdown.identified': 'Танылды',
  'lpr.breakdown.low': 'Төмен сенімділік',
  'lpr.breakdown.failed': 'Сәтсіздіктер',
  'lpr.breakdown.hourColumn': 'Сағат',
  'lpr.breakdown.empty': 'Кезеңде дерек жоқ',

  'lpr.licence.title': 'Жеткізуші лицензияларының шығыны',
  'lpr.licence.calls': 'Өтініштер',
  'lpr.licence.units': 'Бірлік',
  'lpr.licence.failures': 'Қателер',
};

export type LprKey = keyof typeof RU;
export type LprTranslate = (key: LprKey) => string;

export function lprStrings(locale: Locale): LprTranslate {
  const dict: Record<string, string> = locale === 'kk' ? KK : RU;
  return (key) => dict[key] ?? key;
}
